module.exports = __webpack_public_path__ + "img/4_Block.29a166ad.png";